import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AfRoutes } from '../../routes';
import { AppsService } from '../apps/apps.service';

export function cbpGuard(): CanMatchFn {
  return (): Observable<boolean | UrlTree> => {
    const appsService = inject(AppsService);
    const router = inject(Router);

    return appsService.hasCbp().pipe(
      map((hasCbpApp) => hasCbpApp || router.createUrlTree([AfRoutes.welcomePage]))
    );
  };
}
